<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="text"
    track-by="value"
    :options="options"
    :searchable="false"
    :allow-empty="false" />
</template>
<script>
export default {
  name: 'ReservationTypeInput',
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      options: [
        { value: 0, text: this.$t('common.Standard') },
        { value: 1, text: this.$t('common.Entry') },
        { value: 2, text: this.$t('common.Exit') }
      ]
    };
  },
  computed: {
    fieldModelValue: {
      get() {
        if (!this.value) this.$emit('input', 0);
        return (
          this.options.filter((x) => x.value === this.value)
          || this.options.filter((x) => x.value === 0)
        );
      },
      set(newValue) {
        this.$emit('input', newValue.value);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
